const e = {
  name: "CalendarEmpty",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,2h18V0h2v2h3c2.8,0,5,2.2,5,5v28c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h3V0h2V2z M8,4H5
			C3.3,4,2,5.3,2,7v1h34V7c0-1.7-1.3-3-3-3h-3v2h-2V4H10v2H8V4z M2,10v25c0,1.7,1.3,3,3,3h28c1.7,0,3-1.3,3-3V10H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as CalendarEmpty
};
